<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Resource Person</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <v-data-table :headers="headers" :items="resource_person_list" class="elevation-1 mytable" dense :search="search">
        <template v-slot:top>
          <v-toolbar flat dense color="white">
            <!-- <v-toolbar-title>Fees Component</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider> -->
            <v-btn class="ma-2 no-display" rounded outlined small color="success"
                    @click="downloadFile" :loading="loader"><v-icon>mdi-export</v-icon>Export</v-btn>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
            </v-text-field>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn small dense class="button" v-on="on">Add Resource Person</v-btn>
              </template>
              <v-card>
                <v-card-title class="toolbar">
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                            <v-icon color="error">*</v-icon>
                         <v-autocomplete dense required v-model="addedItem.affiliation_type_id"
                          :items="affiliation_type_list" item-text="affiliation_type_name" item-value="affiliaton_type_id" label="Select Affiliation Type" outlined
                          persistent-hint>
                        </v-autocomplete>
                      </v-col>  
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-autocomplete dense required v-model="editedItem.affiliation_type_id"
                          :items="affiliation_type_list" item-text="affiliation_type_name" item-value="affiliaton_type_id" label="Select Affiliation Type" outlined
                          persistent-hint>
                        </v-autocomplete>
                      </v-col>
                     <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                            <v-icon color="error">*</v-icon>
                         <v-autocomplete dense required v-model="addedItem.instructor_id"
                          :items="instructor_list" item-text="employee_code" item-value="instructor_id" label="Select Faculty" outlined
                          persistent-hint>
                        </v-autocomplete>
                      </v-col>  
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-autocomplete dense required v-model="editedItem.instructor_id"
                          :items="instructor_list" item-text="employee_code" item-value="instructor_id" label="Select Faculty" outlined
                          persistent-hint>
                        </v-autocomplete>
                      </v-col>
                       <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                        <v-icon color="error">*</v-icon>
                    <v-text-field dense outlined
                          v-model="addedItem.resource_person_name" label="Name"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-text-field v-model="editedItem.resource_person_name" dense persistent-hint
                           label="Name"></v-text-field>
                      </v-col>
                       <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                        <v-icon color="error">*</v-icon>
                    <v-text-field dense outlined
                          v-model="addedItem.resource_person_email" label="Email"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-text-field v-model="editedItem.resource_person_email" dense persistent-hint
                           label="Email"></v-text-field>
                      </v-col>
                       <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                        <v-icon color="error">*</v-icon>
                    <v-text-field dense outlined
                          v-model="addedItem.resource_person_mobile" label="Mobile"
                           maxlength="10"
                            :rules="mobileRules"
                              @input="addedItem.resource_person_mobile = addedItem.resource_person_mobile.replace(/\D/g, '').slice(0, 10)"
                          ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-text-field v-model="editedItem.resource_person_mobile" dense persistent-hint
                           label="Mobile"
                           maxlength="10"
                            :rules="mobileRules"
                             @input="editedItem.resource_person_mobile = editedItem.resource_person_mobile.replace(/\D/g, '').slice(0, 10)"
                           ></v-text-field>
                      </v-col>
                       <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                        <v-icon color="error">*</v-icon>
                    <v-text-field dense outlined
                          v-model="addedItem.resource_person_designation" label="Designation"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-text-field v-model="editedItem.resource_person_designation" dense persistent-hint
                           label="Designation"></v-text-field>
                      </v-col>
                       <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                        <v-icon color="error">*</v-icon>
                    <v-text-field dense outlined
                          v-model="addedItem.resource_person_organization_name" label="Organization Name"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-text-field v-model="editedItem.resource_person_organization_name" dense persistent-hint
                           label="Organization Name""></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                        <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions style="justify-content:  center;">
                  <!-- <v-spacer></v-spacer> -->
                  <v-btn class="button" @click="close">Cancel</v-btn>
                  <v-btn class="button" @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.isactive="{ item }">
        <v-switch inset dense v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
                        @change="toggle(item)"></v-switch>
        </template>
        <template v-slot:item.status="{ item }">
          <span v-if="item.isactive==true">
            <v-icon class="mr-2 pl-3 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2 pl-3 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
             <v-avatar style="" size="25" class="edit-avatar ml-2">
                <v-icon class="v-icon-size mr-2 ml-2"  @click="deleteItem(item)">delete</v-icon>
             </v-avatar>
             <!-- <v-switch v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'" @change="toggle(item)"></v-switch> -->  
          </div>
          </template>
      </v-data-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
import * as XLSX from "xlsx";
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    overlay: false,
    errorMsg: {
      resource_person_name: false,
      resource_person_email:false,
      resource_person_mobile:false,
      resource_person_email:false,
      resource_person_designation:false,
      resource_person_organization_name:false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    headers: [
    
      {
        text: "Affiliation Type",
        align: "left",
        sortable: false,
        value: "affiliation_type_name",
      },
      {
        text: "Employee Code",
        align: "left",
        sortable: false,
        value: "employee_code",
      },
      {
        text: "Name",
        align: "left",
        sortable: false,
        value: "resource_person_name",
      },
      {
        text: "Email",
        align: "left",
        sortable: false,
        value: "resource_person_email",
      },
      {
        text: "Mobile",
        align: "left",
        sortable: false,
        value: "resource_person_mobile",
      },
      {
        text: "Designation",
        align: "left",
        sortable: false,
        value: "resource_person_designation",
      },
       {
        text: "Orgnization Name",
        align: "left",
        sortable: false,
        value: "resource_person_organization_name",
      },
      {
        text: "Active",
        align: "center",
        sortable: true,
        value: "isactive",
      },
       {
        text: "Status",
        align: "center",
        sortable: true,
        value: "status",
      },
      { text: "Actions", value: "action", sortable: false,align: "center"},
    ],
    resource_person_list: [],
    affiliation_type_list:[],
    instructor_list:[],
    editedIndex: -1,
    addedItem: {
      resource_person_name: "",
      resource_person_email:"",
      resource_person_mobile:"",
      resource_person_email:"",
      resource_person_designation:"",
      resource_person_organization_name:"",
      affiliation_type_id:"",

    },
    editedItem: {
      id: "",
      resource_person_name: "",
      resource_person_email:"",
      resource_person_mobile:"",
      resource_person_email:"",
      resource_person_designation:"",
      resource_person_organization_name:"",
      affiliation_type_id:"",
      isactive: true,
    },
    defaultItem: {
      id: "",
      resource_person_name: "",
      resource_person_email:"",
      resource_person_mobile:"",
      resource_person_email:"",
      resource_person_designation:"",
      resource_person_organization_name:"",
      affiliation_type_id:"",
      isactive: true,
    },
    mobileRules: [
    v => !!v || 'Mobile number is required',
    v => /^[6-9][0-9]{9}$/.test(v) || 'Enter a valid 10 digit mobile number'
],
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Resource Person"
        : "Edit Resource Person";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  mounted() {
    this.onLoad();
  },
  methods: {
    initializeErrorMsgFalse() {
      this.errorMsg.feesComponent = false;
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/Activity/getResourcePerson")
        .then((res) => {
          if (res.data.msg == "200") {
            this.overlay = false;
            // this.activity_type_super_master_list =
            //   res.data.activity_type_super_master_list;
            this.resource_person_list = res.data.resource_person_list;
            this.affiliation_type_list=res.data.affiliation_type_list;
            this.instructor_list=res.data.instructor_list;
            this.load = true;
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          "use strict";
          var overlay = false;
        });
    },
     downloadFile() {
    this.loader = true;

    const excelData = this.resource_person_list.map((item, index) => ({
      "S.No": index + 1,
      "Name": item.resource_person_name,
      "Employee_code":item.employee_code,
       "Email": item.resource_person_email,
       "Mobile": item.resource_person_mobile,
        "Designation": item.resource_person_designation,
        "Organization": item.resource_person_organization_name,
      "Status": item.isactive ? "Active" : "Inactive"
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Resource Person");
    XLSX.writeFile(workbook, "resource_person.xlsx");

    this.loader = false;
  },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.resource_person_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

     deleteItem(item) {
      if (confirm("Are you sure you want to delete this Resource Person")) {
      const data = {
        id: item.id
      };
      axios
        .post("/Activity/deleteResourcePerson", data)
        .then((res) => {
          if (res.data.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Resource Person Deleted Successfully...");
            this.onLoad();
          }
           else {
            this.showSnackbar("#b71c1c", "Something went wrong!");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
      }
      this.close();
    },


    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/Activity/editResourcePerson", this.editedItem)
            .then((res) => {
              if (res.data.status.code == "SUCCESS") {
                Object.assign(
                  this.resource_person_list[this.editedIndex],
                  this.editedItem
                );
                this.showSnackbar(
                  "#4caf50",
                  "Resource Person Updated successfully..."
                ); 
                this.onLoad();
              }
             else if (res.data.status.code == "NA") {
              this.showSnackbar("#b71c1c", "Resource Person already present!!!"); // show snackbar on error
              this.onLoad();
            }
            })
            .catch((error) => {
              window.console.log(error);
            })
            .finally(() => {
              this.addedItem.resource_person_name = "";
               this.addedItem.resource_person_email= "";
                this.addedItem.resource_person_mobile = "";
                 this.addedItem.resource_person_designation = "";
                  this.addedItem.resource_person_organization_name = "";
            });

          this.close();
        }
      } else {
        if(this.addedItem.resource_person_name=="" || this.addedItem.resource_person_name==null){
            this.showSnackbar("#b71c1c", "Please enter Resource Person...");
            return
        }
        axios
          .post("/Activity/saveResourcePerson", this.addedItem)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              this.resource_person_list.push(this.addedItem);
              this.showSnackbar(
                "#4caf50",
                "Resource Person added successfully..."
              ); 
              this.onLoad();
            } else if (res.data.status.code == "NA") {
              this.showSnackbar("#b71c1c", "Resource Person already present!!!"); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          })
          .finally(() => {
            this.addedItem.resource_person_name = "";
            this.addedItem.resource_person_email= "";
            this.addedItem.resource_person_mobile = "";
            this.addedItem.resource_person_designation = "";
            this.addedItem.resource_person_organization_name = "";
          });

        this.close();
      }
    }, 

     toggle(item) {
      const data = {
        id: item.id,
        isactive: item.isactive
      };
      axios
        .post("/Activity/toggleResourcePerson", data)
        .then((res) => {
          if (res.data.status.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Resource Person Updated Successfully...");
            this.onLoad();
          }
           else {
            this.showSnackbar("#b71c1c", "Something went wrong!");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
      this.close();
    },

    isValidated() {
      if (this.editedItem.resource_person_name) {
        return true;
      } else {
        if (!this.editedItem.resource_person_name) {
           this.showSnackbar("#b71c1c", "Please enter Resource Person...");
          this.errorMsg.resource_person_name = true;
        }

        return false;
      }
    },
    
       
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
.active-switch-container {
  display: flex;
  align-items: center;
  height: 100%;
}

.active-switch-container .v-switch {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.mytable ::v-deep tbody tr{
   min-height:50px;
}

.mytable ::v-deep tbody td {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}
</style>
